module.exports = __webpack_public_path__ + "assets/img/8_1564_big.fba5de40.jpg";